/*
 * Kustomer
 */

import ENV from '@src/env'
import axios from 'axios'

const kustomer = function() {
  return {
    data: function() {
      return {
        loadChatAPI: true,
        unreadMessages: 0,
        openConversations: 0,
        word: 'sn_org_',
      }
    },
    computed: {
      KustomerSDK() {
        return Kustomer || window.Kustomer || null // eslint-disable-line
      },
      kustomerEnv() {
        return this.userEnv === 'DEV' ? 'sandbox' : 'prod'
      },
      chatFormId() {
        return ENV.kustomer[this.kustomerEnv].chatFormId
      },
      customParamsConversation() {
        const [tipoYCategoriaEndUserTree] = this.computedTags.filter(tag =>
          this.getTypeCategoryTag(tag)
        )
        return {
          custom: {
            orderIdObligatorioStr: this.$route.query.order_id,
            tipoYCategoriaEndUserTree,
            countryStr: this.$route.query.country_code,
            countryCodeStr: this.$route.query.country_code,
            authorIdStr: this.user.id.toString(),
          },
        }
      },
      customParamsCustomer() {
        return {
          sharedEmails: this.user.email,
          custom: {
            customerTypeStr: 'end_users',
            rawIdStr: this.user.id.toString(),
          },
        }
      },
      conversationAttributes() {
        return {
          name: this.computedSubject,
          tags: this.computedTags,
        }
      },
      computedMessage() {
        return `
          ${this.computedSubject}
          ${this.formatedBody}
        `
      },
    },
    methods: {
      startChat(opts = { icon: false, form: this.chatFormId, new: true }) {
        this.KustomerSDK.start(opts, () => {
          // listen for changes to the unread count
          this.KustomerSDK.on('unread', count => {
            this.unreadMessages = count
            this.openConversationsCount()
          })

          this.KustomerSDK.describeConversation(this.customParamsConversation)
          this.KustomerSDK.describeCustomer(this.customParamsCustomer)
        })
      },
      stopChat() {
        this.KustomerSDK.stop()
      },
      async clearChat() {
        await this.KustomerSDK.clear()
      },
      openChat() {
        this.KustomerSDK.open()
      },
      async openChatAndSendMessage() {
        await this.KustomerSDK.openAndSendMessage({
          body: this.computedMessage,
        })
      },
      updateChatTitle(conversationId) {
        const baseRappi = ENV.rappi.url[this.userEnv]
        const { token, country_code: countryCode } = this.$route.query
        return axios.put(
          `${baseRappi}/api/rappi-kustomer/conversation/${conversationId}`,
          {
            name: this.computedSubject,
            custom: {
              countryCodeStr: countryCode,
              countryStr: countryCode,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
      },
      closeChat() {
        this.KustomerSDK.close({ noIcon: false })
      },
      describeChat(
        type = 'customer',
        params = { custom: { email: 'example' } }
      ) {
        this.KustomerSDK.describe(type, params)
      },
      describeCustomer() {
        this.KustomerSDK.describeCustomer(this.customParamsCustomer)
      },
      async openConversationsCount() {
        const value = await this.KustomerSDK.openConversationsCount()
        this.openConversations = value
      },
      getTypeCategoryTag(str) {
        return new RegExp(this.word).test(str)
      },
    },
  }
}

export default kustomer
